import { UBStep } from '@fry/ui';
import { Walkthrough, WalkthroughStep } from '@fry/walkthroughs/lib';

export class WalkthroughToStepperTranformation {
    public static transform(walkthrough: Walkthrough): UBStep[] {
      if (walkthrough.steps.length === 0) {
        return [];
      }
      return walkthrough.steps.map(step => {
        return WalkthroughToStepperTranformation.transformStep(walkthrough, step);
      });
    }

    private static transformStep(walkthrough: Walkthrough, step: WalkthroughStep): UBStep {
      const steps = step.steps || [];
      const result: UBStep = {
        title: step.title,
        done: step.done,
        next: walkthrough.lastStep() === step
              ? step.done ? false : walkthrough.nextStep() === step
              : walkthrough.nextStep() === step
      };
      if (steps.length > 0) {
        result.steps = step.steps.map(s => {
          return WalkthroughToStepperTranformation.transformStep(walkthrough, s);
        });
      }
      return result;
    }
}
